import styles from "../styles/apuracao.module.css";
import formatTime from "format-hours";

export default function ApuracaoPageTotais({ apuracaoState }: any) {
    const dados = apuracaoState.dados
    const TOTAL = definirHorasTotais(dados.calendario)

    let sinal_horas_saldo = ""
    let bg_horas_saldo = BG_PADRAO
    if (TOTAL.horas_saldo > 10) {
        sinal_horas_saldo = "+"
        bg_horas_saldo = BG_ATENCAO
    } else if (TOTAL.horas_saldo < 0) {
        bg_horas_saldo = BG_NEGATIVO
    }
    let bg_horas_faltas = BG_PADRAO
    if (TOTAL.horas_faltas > 0) {
        bg_horas_faltas = BG_NEGATIVO
    }
    let bg_horas_extras = BG_PADRAO
    if (TOTAL.horas_extras > 0) {
        bg_horas_extras = BG_ATENCAO
    }

    return (
        <div>
            {/* <div className="div-row">
                <p style={pStyle}><b>Totais: </b></p>
                <p style={pStyle}>DT: {TOTAL.dias_trabalhados} DF: {TOTAL.dias_faltas} |</p>
                <p style={pStyle}>Horas Trabalhadas: {TOTAL.HT} |</p>
                <p style={pStyle}>Horas Extras: {TOTAL.HE} |</p>
                <p style={pStyle}>Horas Faltas: {TOTAL.HF} |</p>
                <p style={pStyle}>Horas Noturno: {TOTAL.AN} |</p>
                <p style={pStyle}>Horas Intrajornada: {TOTAL.HI} |</p>
                <p style={pStyle}>Horas Saldo: {TOTAL.HS}</p>
            </div>

            <br></br> */}

            <div className="div-row">
                <div className={styles.totaisContainer}>
                    <p>{TOTAL.HT} | DT: {TOTAL.dias_trabalhados}</p>
                    <p>Horas Trabalhadas</p>
                </div>

                <div className={styles.totaisContainer} style={{ backgroundColor: bg_horas_saldo }}>
                    <p>{sinal_horas_saldo}{TOTAL.HS}</p>
                    <p>Horas Saldo</p>
                </div>

                <div className={styles.totaisContainer} style={{ backgroundColor: bg_horas_faltas }}>
                    <p>{TOTAL.HF} | DF: {TOTAL.dias_faltas}</p>
                    <p>Horas Faltas</p>
                </div>

                <div className={styles.totaisContainer} style={{ backgroundColor: bg_horas_extras }}>
                    <p>{TOTAL.HE}</p>
                    <p>Horas Extras</p>
                </div>

                <div className={styles.totaisContainer}>
                    <p>{TOTAL.HNA} / {TOTAL.HN}</p>
                    <p>Horas Necessárias</p>
                </div>

                <div className={styles.totaisContainer}>
                    <p>{TOTAL.HI}</p>
                    <p>Horas Intrajornada</p>
                </div>

                <div className={styles.totaisContainer}>
                    <p>{TOTAL.AN}</p>
                    <p>Horas Noturnas</p>
                </div>
            </div>
        </div>
    )
}

const BG_PADRAO = "rgb(241, 241, 241)"
// const BG_POSITIVO = "rgba(184, 228, 167, 1)"
const BG_ATENCAO = "#FFFDBF"
const BG_NEGATIVO = "rgb(254, 197, 187)"

// const pStyle: React.CSSProperties = {
//     marginRight: '5px',
// }

function definirHorasTotais(apuracao: any[]):any {
    let totais = {
        horas_necessarias: 0,
        HN: "00:00",
        horas_necessarias_atual: 0,
        HNA: "00:00",
        horas_trabalhadas: 0,
        HT: "00:00",
        horas_extras: 0,
        HE: "00:00",
        horas_saldo: 0,
        HS: "00:00",
        horas_faltas: 0,
        HF: "00:00",
        adicional_noturno: 0,
        AN: "00:00",
        intra_jornada: 0,
        HI: "00:00",
        dias_trabalhados: 0,
        dias_faltas: 0,
    }

    for (let dia of apuracao) {
        totais.horas_necessarias += dia.horas_necessarias
        totais.horas_necessarias_atual += dia.horas_necessarias_atual
        totais.horas_trabalhadas += dia.horas_trabalhadas
        totais.horas_extras += dia.horas_extras
        totais.horas_saldo = totais.horas_saldo + (dia.horas_saldo)
        totais.horas_faltas += dia.horas_faltas
        totais.adicional_noturno += dia.adicional_noturno
        totais.intra_jornada += dia.intra_jornada

        if (dia.registros.length > 0) {
            totais.dias_trabalhados += 1
        }

        if (dia.registros.length === 0 && dia.horas_faltas > 0) {
            totais.dias_faltas += 1
        }
    }

    let saldo_negativo = totais.horas_saldo < 0 ? true : false
    if (saldo_negativo) {
        totais.horas_saldo = totais.horas_saldo * -1
    }

    totais.HN = formatTime(Math.ceil(((totais.horas_necessarias / 60) * 100)) / 100, { fullSize: true })
    totais.HNA = formatTime(Math.ceil(((totais.horas_necessarias_atual / 60) * 100)) / 100, { fullSize: true })
    totais.HT = formatTime(Math.ceil(((totais.horas_trabalhadas / 60) * 100)) / 100, { fullSize: true })
    totais.HE = formatTime(Math.ceil(((totais.horas_extras / 60) * 100)) / 100, { fullSize: true })
    totais.HS = formatTime(Math.ceil(((totais.horas_saldo / 60) * 100)) / 100, { fullSize: true, })
    totais.HF = formatTime(Math.ceil(((totais.horas_faltas / 60) * 100)) / 100, { fullSize: true })
    totais.AN = formatTime(Math.ceil(((totais.adicional_noturno / 60) * 100)) / 100, { fullSize: true })
    totais.HI = formatTime(Math.ceil(((totais.intra_jornada / 60) * 100)) / 100, { fullSize: true })

    if (saldo_negativo) {
        totais.horas_saldo = totais.horas_saldo * -1
        totais.HS = `-${totais.HS}`
    }

    return totais
}
